// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили */
.tableS-subtitle {
  display: grid;
  font-size: 2vw;
  place-self: center;
}
.tableS-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.tableS-logoRun {
  height: 2.1vw;
  place-self: center;
}
.tableS-Scene {
  display: flex;
  flex-direction: column;
  gap: 1vw;
  min-width: 0;
  min-height: 0;
  height: -moz-fit-content;
  height: fit-content;
}

/* Логотип с кнопками и таймером */

.tableS-board-content {
  display: flex;
  gap: 4vw;
}

.tableS-board-logo {
  display: grid;
  grid-template-rows: auto 3vw 3vw;
  gap: 1vw;
  place-items: center;
}

.tableS-board-logo-image {
  place-self: end;
  height: 24vw;
}

#tableS-board-logo-button {
  position: relative;
  left: 1.5vw;
}

#tableS-subtitle-board-logo {
  position: relative;
  left: 1.5vw;
}

/* основное поле */
.tableS-board-game {
  display: flex;
  flex: 1 1;
  margin-right: 2.6vw;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  gap: 1vw;
}

/* поле с кнопкой и полем для проверки отгадки */

.tableS-button-input-board {
  -webkit-user-select: none;
          user-select: none;
  display: grid;
  gap: 0.4vw;
  grid-template-columns: auto auto 8vw;
}

.tableS-input {
  padding-left: 0.8vw;
  font-size: 2vw;
  height: 3vw;
  background-color: #ffffff;
  outline: none;
  text-transform: uppercase;
  border: 0.1vw #1a6a7c solid;
  border-radius: 0.6vw;
}
.tableS-wrong {
  background: #ffc0c0;
}

.tableS-correct {
  background: #e6ffe6;
}

/* карточка перевода победы */
.tableS-card-container {
  display: grid;
  margin-top: auto;
  margin-bottom: auto;
  place-content: center;
  perspective: 1000px;
}

.tableS-card-flipped {
  transform: rotateY(180deg);
}

.tableS-card {
  position: relative;
  display: grid;
  transform-style: preserve-3d;
  transition: transform 2s ease;
}

.tableS-card-face {
  grid-area: 1 / 1;
  display: flex;
  justify-content: center;
  align-items: center;
  backface-visibility: hidden;
}

.tableS-card-front {
}

.tableS-card-back {
  position: absolute;
  inset: 0;

  background: white;
  transform: rotateY(180deg);
}
.tableS-win-square {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}

.tableS-win-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/TablesSecret/styles/TablesSBoard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,gDAAgD;;AAEhD;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Общие стили */\n.tableS-subtitle {\n  display: grid;\n  font-size: 2vw;\n  place-self: center;\n}\n.tableS-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.tableS-logoRun {\n  height: 2.1vw;\n  place-self: center;\n}\n.tableS-Scene {\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n  min-width: 0;\n  min-height: 0;\n  height: fit-content;\n}\n\n/* Логотип с кнопками и таймером */\n\n.tableS-board-content {\n  display: flex;\n  gap: 4vw;\n}\n\n.tableS-board-logo {\n  display: grid;\n  grid-template-rows: auto 3vw 3vw;\n  gap: 1vw;\n  place-items: center;\n}\n\n.tableS-board-logo-image {\n  place-self: end;\n  height: 24vw;\n}\n\n#tableS-board-logo-button {\n  position: relative;\n  left: 1.5vw;\n}\n\n#tableS-subtitle-board-logo {\n  position: relative;\n  left: 1.5vw;\n}\n\n/* основное поле */\n.tableS-board-game {\n  display: flex;\n  flex: 1;\n  margin-right: 2.6vw;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1vw;\n}\n\n/* поле с кнопкой и полем для проверки отгадки */\n\n.tableS-button-input-board {\n  user-select: none;\n  display: grid;\n  gap: 0.4vw;\n  grid-template-columns: auto auto 8vw;\n}\n\n.tableS-input {\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  height: 3vw;\n  background-color: #ffffff;\n  outline: none;\n  text-transform: uppercase;\n  border: 0.1vw #1a6a7c solid;\n  border-radius: 0.6vw;\n}\n.tableS-wrong {\n  background: #ffc0c0;\n}\n\n.tableS-correct {\n  background: #e6ffe6;\n}\n\n/* карточка перевода победы */\n.tableS-card-container {\n  display: grid;\n  margin-top: auto;\n  margin-bottom: auto;\n  place-content: center;\n  perspective: 1000px;\n}\n\n.tableS-card-flipped {\n  transform: rotateY(180deg);\n}\n\n.tableS-card {\n  position: relative;\n  display: grid;\n  transform-style: preserve-3d;\n  transition: transform 2s ease;\n}\n\n.tableS-card-face {\n  grid-area: 1 / 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backface-visibility: hidden;\n}\n\n.tableS-card-front {\n}\n\n.tableS-card-back {\n  position: absolute;\n  inset: 0;\n\n  background: white;\n  transform: rotateY(180deg);\n}\n.tableS-win-square {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n}\n\n.tableS-win-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
